import { AfterViewChecked, Component, OnDestroy, OnInit, EventEmitter, Input, Output,
  ViewContainerRef, OnChanges, NgZone, ViewChild, ElementRef, TemplateRef, ViewEncapsulation } from '@angular/core';
import { DemoService } from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import { Routes, RouterModule, Router } from '@angular/router';

// import { CurrentsDataSourceComponent } from './../../../views/appviews/currents-data-source/currents-data-source.component';
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';



// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import { Observable, Subject } from 'rxjs';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { MysqlService } from './../../../services/mysql.service';
import { BsModalService } from 'ngx-bootstrap';

import { JobSubject } from './../../../shared/models/jobSubject.model';
import { NgForm } from '@angular/forms';
import { GoogleLookupSelection } from './../../../services/autocomplete-component/google-lookup-selection.model';

// :: New data picker sync fusion
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CalendarComponent, DateTimePickerComponent } from '@syncfusion/ej2-angular-calendars';
import {setCulture} from '@syncfusion/ej2-base';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { TabsetComponent, TabsModule } from 'ngx-bootstrap';
import { DataUtil } from '@syncfusion/ej2-data';
import { ToolbarService, HtmlEditorService, CountService, ImageService, LinkService, PasteCleanupService } from '@syncfusion/ej2-angular-richtexteditor';
import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard
import { HotToastService } from '@ngneat/hot-toast';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentEditorComponent, DocumentEditorContainerComponent } from '@syncfusion/ej2-angular-documenteditor';
import { LegalDateTimeService } from '../../../services/legal-datetime.service';


setCulture('au');
// :: Define and declare google as Var
// :: also remember to place mapping api javascipt in index.html of this app.
// ::@ https://github.com/dhormale/google-places-autocomplete
declare var google: any;

interface LookupFormValues {
  streetAddress: string;
  suburb: any;
  state: any;
  postcode: any;
  phone: any;
  placeName: any;
}

@Component({
  selector: 'app-subject-details-edit-widget',
  templateUrl: './subject-details-edit-widget.component.html',
  styleUrls: ['./subject-details-edit-widget.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, CountService, PasteCleanupService ]
})
export class SubjectDetailsEditWidgetComponent implements OnInit, OnChanges, AfterViewChecked {

  // setup as observable?
  // @Input() item_id?: Observable<any[]>; // impliments on changes.
  @Input() item_id?; // impliments on changes.
  @Input() item_data?: any; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data?= 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id?= '5'; // default to agent just in case
  @Input() item_brand_type_id?= '';
  @Input() show_buttons?= 'no'; // yes | no
  @Input() widget_title?= '';
  @Input() widget_size?= 'side'; // side | abstract | full | admincard

  @ViewChild('defaultRTE')
  public defaultRTE: DocumentEditorComponent;

  @Input() tab_index?;
  @Output() subjectValidationStatusChanged = new EventEmitter<any>();



  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  job: any;
  JobStep2ID: any;
  model!: JobSubject;
  job_types: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  clients: any;
  client_contacts: any;
  sent_client_id: any;
  positionsMysql: any;
  get_subjects: any;
  job_subject_types: any;
  job_plaintiff_types: any;
  sessionUsername: any;
  brands: any;
  brand_users: any;
  sent_brand_id: any;
  brand_report_selected: any;
  selected_brand_data: any;
  new_special_instuctions: any;
  special_instructions: any;
  job_id: any;
  subjects: any;
  job_status: any;


  // ::::[ Google API Address Component
  address: any;
  establishmentAddress: any;
  formattedAddress: string;
  formattedEstablishmentAddress: string;
  phone: string;
  postalcode: any;
  street: any;
  // ::
 
 // :: old model to access the dom, does not update the model! Stupid really
  @ViewChild('postcode') postcodeElement: ElementRef;
  @ViewChild('street_address') streetAddressElement: ElementRef;
  @ViewChild('suburb') suburbElement: ElementRef;
  @ViewChild('state') stateElement: ElementRef;
  @ViewChild('phone_h') phone_hElement: ElementRef;
  @ViewChild('business_name') business_nameElement: ElementRef;


 // :: call back results of Google API
 @ViewChild('SubjectForm') SubjectForm: NgForm;
  streetNumber: (place: any) => any;
  district: (place: any) => any;
  state: (place: any) => any;
  country: (place: any) => any;
  city: (place: any) => any;
  country_short: any;
  place_name: any;
  subject_id: any;
  addressSelection: GoogleLookupSelection;
  establishmentAddressSelection: GoogleLookupSelection;
  client_job_submission: any;
  job_service_rule: any;
  job_service_rules: any;
  job_service_timeframes: any;
  job_service_timeframe: any;
  selected_job_service_rule_description: any;
  selected_job_service_timeframe_description: any;
  subject_service_types: any;
  subject_service_type: any;
  selected_subject_service_type_description: any;
  selected_subject_service_type_instructions: any;
  selected_subject_service_type_staff_instructions: any;
  all_router_details: string;
  DialogObj: any;
  loadFindAddress: boolean;
  loadFindBusinessAddress: boolean;
  modalRef: any;
  subject_contact_emails: any;
  subject_contact_numbers: any;
  file_number: any;
  subject_number: any;
  metric_1_date_1: Date;
  metric_1_date_2: Date;
  date_of_service: string | number | Date;
  job_start_date: any;
  job_start_date_words: string;
  job_duration: string;
  job_subject_documents: any;
  initialCount = 0; // Put this in the master -> for child component
  selected_subject_id: any;
  // :::::[ end google API

  
  // TABS sets the selected
  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs!: TabsetComponent;
  selected_tab?: number;
  all_job_subjects: any;
  all_job_subjects_count: any;
  changes_made: any = 1;
  subjects_urgent2: any;
  job_subjects_count: any;
  job_subjects_not_closed_count: any;
  current_subject_job_status: any;

interval = 15;
  brand_report_user_id: any;
  current_owner_trace_code: any;
  subpremise: any;
  showPrevVersion_Field: any;


  // Text editor Settings
  public simpleToolBar: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo',
    // {
    //   tooltipText: 'Insert Promotion',
    //   undo: true,
    //   click: this.onClickPromotionButton.bind(this),
    //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
    // }
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };
    public pasteCleanupSettings: object = {
      prompt: true,
      plainText: false,
      keepFormat: false,
      deniedTags: ['a'],
      deniedAttrs: ['class', 'title', 'id'],
      allowedStyleProps: ['color', 'margin', 'font-size']
  }; 
  job_plaintiffs: any;
  timeframe_surcharges: any;
  current_client_additional_create_data_HTML: any;


  public opened() {
    this.defaultRTE.refresh();
    // this.RTEemail_template_owner.refreshUI();
  }

  nextDatePickerValues: { [key: string]: Date | null } = {};
  finalDatePickerValues: { [key: string]: Date | null } = {};
  private lastSubjectValidationSignature = '';

  constructor(private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute,
    vcr: ViewContainerRef, private router: Router, 
    public HttpClient: HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    public zone: NgZone, // added for google address API component
    postcodeElement: ElementRef,
    private clipboard: Clipboard, // ciipboard
    public toastr: HotToastService,
    private sanitizer: DomSanitizer,
    public legalDate: LegalDateTimeService,
  ) {

    // form settings
   // this.postcodeElement = postcodeElement;

    this.nav = document.querySelector('nav.navbar');
    // this.toastr.setRootViewContainerRef(vcr);

 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));





  }

 

  // check for changes. to load data.
  ngOnChanges(changes) {
    if (changes.item_id) {

      this.model = new JobSubject();

  // Pause the load by 1 second so that it load up to 25 subjects at once in include file.
// This function is very important and now pauses then load the document correctly.
        // setTimeout(() => {  
        //   console.log("A Simple Pause! OnChanges 4"); 
        //      console.log("Now Ready to load...");
        //   }, 4000);
        
      // deal with asynchronous Observable result
     // this.job_id = changes.item_id.currentValue;
     this.subject_id = changes.item_id.currentValue;
     this.selected_subject_id = this.subject_id;
    

    
            setTimeout(() => {  
          console.log("A Simple Pause! OnChanges 2");
          this.getJobSubject(this.subject_id); 
             console.log("Now Ready to load...");
          }, 2000);
  


     this.getJobStatusNames();
     this.getJobSubjectDocumentsBySubjectID(this.subject_id);

    // this.getJobSubjectTypes();
    // this.model = new JobSubject(); // setup the form binding to model

        setTimeout(() => {  
          console.log("A Simple Pause! Loading the Service Rules Drop Downs"); 

          this.getJobSubjectTypes();
          this.getJobServiceRules();
          this.getJobServiceTimeframes();
          this.getSubjectServiceTypes();

          this.getTimeframeSurcharges();


            console.log("Now Ready to load...");
  }, 1000);





    }




    // from sent data
    if (changes.item_data) {

      // deal with asynchronous Observable result
     // this.model = new JobSubject(); // setup the form binding to model
     // this.model = new JobSubject();
     this.subjects = changes.item_data.currentValue;
     this.initializeSubjectPickerValues(this.subjects);
     this.getJobStatusNames();
   ///  this.getJobSubjectTypes();
 
    }
  }


  ngOnInit() {
    // this.JobStep2ID = +this.route.snapshot.paramMap.get('job_id');

    //  this.getJob(this.JobStep2ID);
    // this.model.job_type_location_id = this.job.job_type_location_id;


    // this.getJobTypeLocations(this.model.job_type_location_id); // loads default locations as nothing
  }

  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
      data => {
        this.subjects = data;
        let res = data[0];
        this.initializeSubjectPickerValues(this.subjects);


  //       setTimeout(() => {  
  //         console.log("A Simple Pause! on get subject 1 inside function"); 
  //           console.log("Now Ready to load...");
  // }, 1000);
   
       this.job_id = res.job_id;
        this.file_number = res.file_number;
        this.subject_number = res.subject_number;



        // set the default descriptions
            setTimeout(() => {  
                  // get the subjects counts
            this.getJobsTableDataSubjects(this.job_id);
            this.getJob(this.job_id);

            this.getJobPlaintiffs(this.job_id);
    
          console.log("A Simple Pause! Loading the rules selected"); 
          this.getSubjectServiceType(res.subject_service_type_id);
          this.getJobServiceRule(res.job_service_rule_id);
          this.getJobServiceTimeframe(res.job_service_timeframe_id);
             console.log("Now Ready to load...");
          }, 2000);
     

        // contact numbers and emails
        this.getSubjectContactEmails(subject_id);
        this.getSubjectContactNumbers(subject_id);
 // checker for the delete button
        this.getJobSubjects(res.job_id);


        let metric_1_date_1 = this.legalDate.toAuditDate(res.created_date) ?? new Date(res.created_date * 1000);
        let metric_1_date_2 = new Date();
        
        this.job_start_date = metric_1_date_1;
        this.job_start_date_words = this.gfunc.dhm(metric_1_date_1);
        // tslint:disable-next-line:max-line-length
        let duration_calc = metric_1_date_2.getTime() - metric_1_date_1.getTime(); // milliseconds // bigger date first so no negatives
        this.job_duration = this.gfunc.dhm(duration_calc);

        this.getSubjectContactNumbers(subject_id);


     


       
      },
      err => console.log(err),
      // () => console.log('done loading')
    );
  }

  // june 2025 fix.
  updateJobSubjectFixBrandReportContactID(model){

    let new_model = {
      ...model,
      brand_report_user_id: this.brand_report_user_id
    }

    this.updateJobSubject(new_model)

  }


  updateJobSubject(model) {
    // first make a copy of subject and place in to subject_history table. // done on insert in PHP
    model.updated_by = this.sessionUserId;


    // Commented out in june 2025 as it was changing the brand report subject id on save... after it was submitted.
    // only set now if user does not exists.. and now gets from the job directly upon update and save. FIXES IT>..!!!!
    if(model.brand_report_user_id < 1){
    model.brand_report_user_id = this.brand_report_user_id; // was missing in all logs and save model of subject
    }

    model.owner_trace_code = this.current_owner_trace_code; // was missing in all logs and save model of subject this way we have an email header....



    // Set bew field Automatically on update. if null.
    // commentred out june 2025 as it is no longer required to have this field.
        // if (model.special_instructions_HTML == null){
        //   model.special_instructions_HTML = model.special_instructions;
        // }

    this._demoService.updateJobSubject(model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
        // this.toastr.success('Subject Updated');
        this.onOpenDialogSaveSubject(model);
        // TraceCandidateManagerComponent.returned.next(false);
        // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);

          // set for notice and log
          let subject_name = model.first_name + '' + model.surname;
          let subject_business_name = model.business_name;
          
                  if(subject_business_name != ''){
                        subject_name = subject_business_name;
                    }
            model.subject_name = subject_name;
          // Need to insert a system log and note.
          this.gfunc.insertLog_UpdateSubjectGeneral(model);

        
        if (this.gfunc.current_base_route === '/admin/jobs/subject/edit' || this.gfunc.current_base_route === '/staff/jobs/subject/edit' 
        || this.gfunc.current_base_route === '/admin/jobs/subject/card' ) {
          this.gfunc.globalJobSubjectViewSkipRoute(model.subject_id);
        }else{
        
          // this.gfunc.globalJobEditStep3(model.job_id); // changed to see that subbject type is saving
          this.gfunc.globalJobEditStep3SkipRoute(model.job_id) // this worked.

      }

        return true;
      },
      error => {
        // console.error('Error saving Event!');
        // this.toastr.error('Error saving Job!');
       return console.log(error);
      }
      // err => console.log(err),
      // () => console.log('done updates')


    );
  }



  private getJobStatusNames() {
    this._demoService.getJobStatusNames()
      .subscribe(
        res => this.job_status = res,
        err => console.error(err.status)
      );
  }


  getJob(job_id) {
 


 
    // this.getJobTypes();
    // this.getPositions();
    // this.getClients();
    // this.getJobSubjectTypes();
    // this.getJobPlaintiffTypes();
    // this.getBrands();

    this._demoService.getJobID(job_id).subscribe(
      data => {
        this.job = data;
        let res = data[0];
        // Need to load the drop downs (only if a process is selected.)
        // this.getJobTypeLocations(res.job_type_id);
        // this.getJobTypeCourts(res.job_type_location_id);
        // this.getJobTypeDocumentTypes(res.job_type_court_id);
        // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
        // // need to load client contact
        // this.getClientContactsSharmans(res.client_id);

     


          this.current_subject_job_status = this.job[0].job_status_code;
          this.current_owner_trace_code = this.job[0].owner_trace_code;

     

     
        // this.getBrandUsers(res.brand_report_id); // this was setting the wong brand report ID upon save june 2025
          // fix for changing the job subject,
      this.brand_report_user_id = this.job[0].brand_report_user_id;

      this.current_client_additional_create_data_HTML = this.job[0].client_additional_create_data_HTML





      },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );


  }


  // BOF SHARMANS CALLS
  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
      data => { this.job_types = data; },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getJobSubjectTypes() {
    this._demoService.getJobSubjectTypes().subscribe(
      data => { this.job_subject_types = data; },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getJobPlaintiffTypes() {
    this._demoService.getJobPlaintiffTypes().subscribe(
      data => { this.job_plaintiff_types = data; },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
      data => { this.job_type_locations = data; },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );
  }


  sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....



    console.log('sending Count:' + this.count2);
  }


  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
      data => { this.job_type_courts = data; },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );
  }


  sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....



    // console.log('sending Location:' + this.sent_job_type_location_id);
  }


  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
      data => { this.job_type_document_types = data; },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );
  }


  sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....


    // console.log('sending Court Type:' + this.sent_job_type_court_id);
  }


  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
      data => { this.job_type_affidavit_types = data; },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );
  }


  sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....

    console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }



  getClients() {
    this._demoService.getClients().subscribe(
      data => { this.clients = data; },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getClientContactsSharmans(client_id) {
    this._demoService.getClientContactsSharmans(client_id).subscribe(
      data => { this.client_contacts = data; },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );
  }

  sendClientID(client_id) {
    this.sent_client_id = client_id;
    this.getClientContactsSharmans(this.sent_client_id); // updates the selected job ID....

    // console.log('sending Client ID:' + this.sent_client_id);
  }

  private getPositions() {
    this._demoService.getPositions()
      .subscribe(
        res => this.positionsMysql = res,
        err => console.error(err.status)
      );
  }



  // update was here for onit but moved for onchange
  updateJobAll(model) {
    model.updated_by = this.sessionUserId;
    this._demoService.updateJobAll(model).subscribe(
      data => {
        // this.toastr.success('Job Updated');
        // Subject to reload the manager component parent.
        // TraceCandidateManagerComponent.returned.next(false); // refreshed below component?
        this.gfunc.globalJobView(model.job_id);
      },
      error => {
        // console.error('Error saving Event!');
        // this.toastr.error('Error updating your Job!');
       return console.log(error);
      }
    );
  }



  // create subjects
  createJobSubjectsMultiple(model) {

    this._demoService.createJobSubjectsMuliple(model).subscribe(
      data => {
        this.get_subjects = data; // this is the retuned json upon creation.
        // this.toastr.success('Subjects Saving...');
        // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}

        // Setup annd the Currents before we redirec the page
        // Needs to be a Function to update the ObserveOnOperator.
        // this.newCTrace_id(this.latest_trace_id);
        // or this.cdata.changeCTrace_id("999");

        // this.router.navigate(['/admin/jobs/create-job-2/' + model.job_id + '']);

        return true;


      },
      error => {
        // console.log('Should be form Model' + model);
        // console.error('Error Creating a Trace Project!');
        // this.toastr.error('Adding Subjects Failed :: Please try again!');
        // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
    );
  }

  getBrands() {
    this._demoService.getBrands().subscribe(
      data => { this.brands = data; },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getBrandUsers(brand_report_user_id) {
    this._demoService.getBrandUsers(brand_report_user_id).subscribe(
      data => { this.brand_users = data;


        // was getting the inccrect brand report user id commented out and remove the function june 2025
   //   this.brand_report_user_id = this.brand_users[0].user_id;


       },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );
  }

  sendBrandID(brand_report_user_id) {
    this.sent_brand_id = brand_report_user_id;
    this.getBrandUsers(this.sent_brand_id); // updates the selected job ID....
    // need to look up what brands notes are and send to jon notes.
    // lookup brand
    this.getBrandById_instructions(this.sent_brand_id); // sets the model special instuctions in function

    //console.log('sending Brand ID:' + this.sent_brand_id);
  }

  getBrandById_instructions(brand_id) {
    this._demoService.getBrandById(brand_id)
      .subscribe(
        res => {
          this.brand_report_selected = res;
          this.selected_brand_data = res[0];
          this.new_special_instuctions = this.selected_brand_data.brand_notes;
          this.special_instructions = this.new_special_instuctions;
          // console.log('instructions: ' + this.new_special_instuctions);

        },
        err => console.error(err.status)
      );
  }



  getAddress(selection: GoogleLookupSelection) {
    const place = selection && selection.place ? selection.place : null;

    if (!place) {
      return;
    }

    this.addressSelection = selection;
    this.address = selection.lookupText || place['formatted_address'];
    this.phone = this.getPhone(place) || place['formatted_phone_number'];
    this.formattedAddress = place['formatted_address'] || selection.lookupText;
    this.street = this.getStreet(place);
    this.postalcode = this.getPostCode(place);
    this.streetNumber = this.getStreetNumber(place);
    this.city = this.getCity(place);
    this.district = this.getDistrict(place);
    this.state = this.getState(place);
    this.country = this.getCountry(place);
    this.country_short = this.getCountryShort(place);
    this.subpremise = this.getStreetNumberSubpremise(place);

    if (this.zone) {
      this.zone.run(() => this.formattedAddress = place['formatted_address'] || selection.lookupText);
    } else {
      this.formattedAddress = place['formatted_address'] || selection.lookupText;
    }
  }

  ngAfterViewChecked(): void {
    this.emitSubjectValidationStatusIfChanged();
  }

  private emitSubjectValidationStatusIfChanged(): void {
    if (!this.SubjectForm || !this.subjects || !this.subjects[0]) {
      return;
    }

    const invalidFields = this.getInvalidSubjectFormFields();
    const subjectModel = this.subjects[0];
    const payload = {
      subject_id: subjectModel.subject_id || this.subject_id,
      subject_number: subjectModel.subject_number || subjectModel.file_number || this.tab_index,
      tab_index: this.tab_index,
      valid: this.SubjectForm.form.valid && invalidFields.length === 0,
      invalid_fields: invalidFields
    };
    const signature = JSON.stringify(payload);

    if (signature === this.lastSubjectValidationSignature) {
      return;
    }

    this.lastSubjectValidationSignature = signature;
    setTimeout(() => this.subjectValidationStatusChanged.emit(payload));
  }

  private getInvalidSubjectFormFields(): string[] {
    if (!this.SubjectForm || !this.SubjectForm.controls) {
      return [];
    }

    const invalidFieldNames = Object.keys(this.SubjectForm.controls)
      .filter(controlName => this.SubjectForm.controls[controlName]?.invalid)
      .map(controlName => this.getSubjectFormFieldLabel(controlName));

    return Array.from(new Set(invalidFieldNames));
  }

  private getSubjectFormFieldLabel(controlName: string): string {
    const labels = {
      next_date: 'Next Date',
      final_date: 'Final Date',
      job_status: 'Job Status',
      timeframe_surcharge_id: 'Timeframe',
      first_name: 'First Name',
      middle_name: 'Middle Name',
      surname: 'Surname',
      sex: 'Sex',
      dob: 'D.O.B.',
      job_subject_type_id: 'Subject Type',
      is_active: 'Active Status',
      business_name: 'Business Name',
      street_address: 'Street Address',
      suburb: 'Suburb',
      state: 'State',
      postcode: 'Postcode',
      phone_m: 'Mobile Phone',
      phone_h: 'Home Phone',
      email: 'Email',
      subject_service_type_id: 'Subject Service Type',
      job_service_rule_id: 'Document Service Rule',
      service_company_name: 'Service Company Name',
      service_directors_name: 'Director Name',
      service_prison_name: 'Prison Name',
      service_solicitor_name: 'Solicitor Name',
      service_law_firm_name: 'Law Firm Name',
      job_service_timeframe_id: 'Document Service Timeframe',
      special_instructions: 'Special Instructions',
      special_instructions_HTML: 'Special Instructions'
    };

    return labels[controlName] || controlName.replace(/_/g, ' ');
  }

  getSubjectDateKey(model: any): string {
    return String(model?.subject_id ?? model?.job_id ?? '');
  }

  onSubjectNextDateChange(value: unknown, model: any): void {
    const key = this.getSubjectDateKey(model);
    const pickerDate = this.legalDate.coercePickerDate(value);
    this.nextDatePickerValues[key] = pickerDate;
    model.next_date = this.legalDate.fromPickerDate(pickerDate);
  }

  onSubjectFinalDateChange(value: unknown, model: any): void {
    const key = this.getSubjectDateKey(model);
    const pickerDate = this.legalDate.coercePickerDate(value);
    this.finalDatePickerValues[key] = pickerDate;
    model.final_date = this.legalDate.fromPickerDate(pickerDate);
  }

  private initializeSubjectPickerValues(subjects: any[]): void {
    if (!Array.isArray(subjects)) {
      this.nextDatePickerValues = {};
      this.finalDatePickerValues = {};
      return;
    }

    const nextDatePickerValues: { [key: string]: Date | null } = {};
    const finalDatePickerValues: { [key: string]: Date | null } = {};

    subjects.forEach((subject) => {
      const key = this.getSubjectDateKey(subject);
      nextDatePickerValues[key] = this.legalDate.toPickerDate(subject?.next_date);
      finalDatePickerValues[key] = this.legalDate.toPickerDate(subject?.final_date);
    });

    this.nextDatePickerValues = nextDatePickerValues;
    this.finalDatePickerValues = finalDatePickerValues;
  }

  getAddressApply() {
    this.applyLookupSelectionToSubjectForm(this.addressSelection);
  }





  // :: Created Function to set subject form values upon lookup.
  // :: DID not work as form has differt IDs.
  setAddressValues(streetNumber, street, suburb, state, postcode, phone) {
    this.model.street_address = streetNumber + ' ' + street;
    this.model.suburb = suburb;
    this.model.state = state;
    this.model.postcode = postcode;
    this.model.phone_h = phone;
  }





  

  // :: Gooogle Address Extra Functions to work with
  getEstablishmentAddress(selection: GoogleLookupSelection) {
    const place = selection && selection.place ? selection.place : null;

    if (!place) {
      return;
    }

    this.establishmentAddressSelection = selection;
    this.establishmentAddress = selection.lookupText || place['formatted_address'];
    this.phone = place['international_phone_number'] || place['formatted_phone_number'] || this.getPhone(place);
    this.street = this.getStreet(place);
    this.streetNumber = this.getStreetNumber(place);
    this.subpremise = this.getStreetNumberSubpremise(place);
    this.city = this.getCity(place);
    this.district = this.getDistrict(place);
    this.postalcode = this.getPostCode(place);
    this.state = this.getState(place);
    this.country = this.getCountry(place);
    this.country_short = this.getCountryShort(place);
    this.formattedEstablishmentAddress = place['formatted_address'] || selection.lookupText;
    this.place_name = place['name'];

    if (this.zone) {
      this.zone.run(() => {
        this.formattedEstablishmentAddress = place['formatted_address'] || selection.lookupText;
        this.phone = place['international_phone_number'] || place['formatted_phone_number'] || this.getPhone(place);
        this.place_name = place['name'];
      });
    }
  }

  getEstablishmentAddressApply() {
    this.applyLookupSelectionToSubjectForm(this.establishmentAddressSelection, true);
  }

  private applyLookupSelectionToSubjectForm(selection: GoogleLookupSelection, includeBusinessName = false) {
    if (!selection || !selection.place) {
      if (this.toastr) {
        this.toastr.warning('Select an address lookup result first.');
      }
      return;
    }

    const formValues = this.getLookupFormValues(selection, includeBusinessName);

    this.setSubjectControlValue('street_address', formValues.streetAddress);
    this.setSubjectControlValue('suburb', formValues.suburb);
    this.setSubjectControlValue('state', formValues.state);
    this.setSubjectControlValue('postcode', formValues.postcode);
    this.setSubjectControlValue('phone_h', formValues.phone);

    if (includeBusinessName) {
      this.setSubjectControlValue('business_name', formValues.placeName);
    }
  }

  private setSubjectControlValue(controlName: string, value: any) {
    if (this.SubjectForm && this.SubjectForm.controls && this.SubjectForm.controls[controlName]) {
      this.SubjectForm.controls[controlName].setValue(value == null ? '' : value);
    }
  }

  private getLookupFormValues(selection: GoogleLookupSelection, stripPlaceName = false): LookupFormValues {
    const place = selection.place;

    return {
      streetAddress: this.buildLookupAddress(selection, stripPlaceName),
      suburb: this.getCity(place),
      state: this.getState(place),
      postcode: this.getPostCode(place),
      phone: place['international_phone_number'] || place['formatted_phone_number'] || this.getPhone(place),
      placeName: place['name']
    };
  }

  buildLookupAddress(selection: GoogleLookupSelection, stripPlaceName = false): string {
    const place = selection && selection.place ? selection.place : null;

    if (!place) {
      return '';
    }

    const lookupText = this.getLookupText(selection);
    const lookupAddressBeforeLocality = this.getLookupAddressBeforeLocality(lookupText, place);
    const streetNumber = this.getStreetNumber(place);
    const street = this.getStreet(place);
    const subpremise = this.getStreetNumberSubpremise(place);
    const premise = this.getPremise(place);
    const floor = this.getFloor(place);
    const streetLine = this.joinAddressParts([streetNumber, street], ' ');
    const lookupStreetAddress = lookupAddressBeforeLocality || this.getLookupStreetAddress(
      lookupText,
      streetLine,
      [subpremise, premise, floor]
    );

    if (lookupStreetAddress) {
      const strippedLookupStreetAddress = stripPlaceName
        ? this.stripLeadingPlaceNameSegment(lookupStreetAddress, place['name'])
        : lookupStreetAddress;

      if (strippedLookupStreetAddress) {
        return this.capitaliseLeadingWord(strippedLookupStreetAddress);
      }
    }

    const premiseParts = [subpremise, premise, floor];
    const filteredPremiseParts = stripPlaceName
      ? premiseParts.filter(part => !this.matchesPlaceName(part, place['name']))
      : premiseParts;
    const componentStreetAddress = this.joinAddressParts([filteredPremiseParts[0], streetLine], ', ');

    if (componentStreetAddress) {
      return this.capitaliseLeadingWord(componentStreetAddress);
    }

    return this.capitaliseLeadingWord(lookupStreetAddress || this.joinAddressParts([subpremise || premise || floor, streetLine], ', '));
  }

  private getLookupAddressBeforeLocality(lookupText: string, place: any): string {
    const segments = this.stripTrailingLocationSegments(this.splitLookupText(lookupText), place);

    if (segments.length) {
      return this.joinAddressParts(segments, ', ');
    }

    return '';
  }

  private getLookupStreetAddress(lookupText: string, streetLine: string, unitCandidates: any[]): string {
    const segments = this.splitLookupText(lookupText);
    const hasUnitDetails = !!this.joinAddressParts(unitCandidates, '');

    if (!segments.length) {
      return '';
    }

    const streetIndex = this.findStreetSegmentIndex(segments, streetLine);

    if (streetIndex >= 0) {
      const streetSegment = segments[streetIndex];

      if (hasUnitDetails && streetIndex > 0 && this.isLikelyUnitPrefix(segments[streetIndex - 1], unitCandidates)) {
        return this.joinAddressParts([segments[streetIndex - 1], streetSegment], ', ');
      }

      if (hasUnitDetails && streetIndex === 0 && streetSegment !== streetLine && this.isLikelyUnitPrefix(streetSegment, unitCandidates)) {
        return streetSegment;
      }

      return streetSegment;
    }

    return this.joinAddressParts(segments.slice(0, hasUnitDetails ? 2 : 1), ', ');
  }

  private stripTrailingLocationSegments(segments: string[], place: any): string[] {
    const addressSegments = segments.slice();

    while (addressSegments.length && this.isCountrySegment(addressSegments[addressSegments.length - 1], place)) {
      addressSegments.pop();
    }

    while (addressSegments.length && this.isLikelyLocalitySegment(addressSegments[addressSegments.length - 1], place)) {
      addressSegments.pop();
    }

    return addressSegments;
  }

  private isCountrySegment(segment: string, place: any): boolean {
    const normalisedSegment = this.normalizeAddressText(segment);
    const countryMarkers = [
      this.getCountry(place),
      this.getCountryShort(place)
    ]
      .map(value => this.normalizeAddressText(value))
      .filter(value => !!value);

    if (!normalisedSegment || !countryMarkers.length) {
      return false;
    }

    for (let i = 0; i < countryMarkers.length; i++) {
      const marker = countryMarkers[i];

      if (normalisedSegment === marker) {
        return true;
      }
    }

    return false;
  }

  private isLikelyLocalitySegment(segment: string, place: any): boolean {
    const normalisedSegment = this.normalizeAddressText(segment);
    const localityMarkers = [
      this.getCity(place),
      this.getState(place),
      this.getPostCode(place),
      this.getDistrict(place)
    ]
      .map(value => this.normalizeAddressText(value))
      .filter(value => !!value);

    if (!normalisedSegment || !localityMarkers.length) {
      return false;
    }

    let markerMatches = 0;

    for (let i = 0; i < localityMarkers.length; i++) {
      const marker = localityMarkers[i];

      if (normalisedSegment === marker) {
        return true;
      }

      if (normalisedSegment.indexOf(marker) >= 0) {
        markerMatches++;
      }
    }

    return markerMatches >= 2;
  }

  private splitLookupText(lookupText: string): string[] {
    return (lookupText || '')
      .split(',')
      .map(segment => (segment || '').trim())
      .filter(segment => !!segment);
  }

  private findStreetSegmentIndex(segments: string[], streetLine: string): number {
    const normalisedStreetLine = this.normalizeAddressText(streetLine);

    if (!normalisedStreetLine) {
      return -1;
    }

    for (let i = 0; i < segments.length; i++) {
      if (this.normalizeAddressText(segments[i]).indexOf(normalisedStreetLine) >= 0) {
        return i;
      }
    }

    return -1;
  }

  private isLikelyUnitPrefix(segment: string, unitCandidates: any[]): boolean {
    const normalisedSegment = this.normalizeAddressText(segment);
    const unitPrefixPattern = /(^|\b)(unit|suite|shop|apt|apartment|level|floor|lot|room|factory|warehouse)\b/;

    if (!normalisedSegment) {
      return false;
    }

    if (unitPrefixPattern.test(normalisedSegment)) {
      return true;
    }

    for (let i = 0; i < unitCandidates.length; i++) {
      const candidate = this.normalizeAddressText(unitCandidates[i]);

      if (candidate && normalisedSegment.indexOf(candidate) >= 0) {
        return true;
      }
    }

    return false;
  }

  private normalizeAddressText(value: any): string {
    return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  }

  private joinAddressParts(parts: any[], separator: string): string {
    const result = [];

    for (let i = 0; i < parts.length; i++) {
      const nextValue = parts[i];

      if (nextValue !== undefined && nextValue !== null && String(nextValue).trim() !== '') {
        result.push(String(nextValue).trim());
      }
    }

    return result.join(separator).trim();
  }

  private capitaliseLeadingWord(value: string): string {
    return (value || '').replace(/^([A-Za-z])([A-Za-z']*)/, (match, firstLetter, remainingLetters) => {
      return firstLetter.toUpperCase() + remainingLetters.toLowerCase();
    });
  }

  private stripLeadingPlaceNameSegment(addressText: string, placeName: string): string {
    const segments = this.splitLookupText(addressText);

    if (!segments.length) {
      return '';
    }

    if (this.matchesPlaceName(segments[0], placeName)) {
      return this.joinAddressParts(segments.slice(1), ', ');
    }

    return addressText;
  }

  private matchesPlaceName(value: any, placeName: string): boolean {
    const normalisedValue = this.normalizeAddressText(value);
    const normalisedPlaceName = this.normalizeAddressText(placeName);

    return !!normalisedValue && !!normalisedPlaceName && normalisedValue === normalisedPlaceName;
  }

  private getLookupText(selection: GoogleLookupSelection): string {
    if (!selection) {
      return '';
    }

    if (selection.lookupText) {
      return selection.lookupText;
    }

    if (selection.place && selection.place['formatted_address']) {
      return selection.place['formatted_address'];
    }

    return '';
  }


  // functions to get objects?
  getAddrComponent(place, componentTemplate) {
    let result;

    if (!place || !place.address_components) {
      return;
    }

    for (let i = 0; i < place.address_components.length; i++) {
      const component = place.address_components[i];
      const componentTypes = component.types || [];

      for (let j = 0; j < componentTypes.length; j++) {
        const addressType = componentTypes[j];

        if (componentTemplate[addressType]) {
          result = component[componentTemplate[addressType]];
          return result;
        }
      }
    }
    return;
  }

  getStreetNumber(place) {
    // const COMPONENT_TEMPLATE = { street_number: 'short_name' },
    const COMPONENT_TEMPLATE = { street_number: 'long_name' },
      streetNumber = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return streetNumber;
  }

  getStreetNumberSubpremise(place) {
    // const COMPONENT_TEMPLATE = { street_number: 'short_name' },
    const COMPONENT_TEMPLATE = { subpremise: 'long_name' },
      subpremise = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return subpremise;
  }

  getPremise(place) {
    const COMPONENT_TEMPLATE = { premise: 'long_name' },
      premise = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return premise;
  }

  getFloor(place) {
    const COMPONENT_TEMPLATE = { floor: 'long_name' },
      floor = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return floor;
  }

  getStreet(place) {
    const COMPONENT_TEMPLATE = { route: 'long_name' },
      street = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return street;
  }

  getCity(place) {
    const COMPONENT_TEMPLATE = { locality: 'long_name' },
      city = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return city;
  }

  getState(place) {
    const COMPONENT_TEMPLATE = { administrative_area_level_1: 'short_name' },
      state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return state;
  }

  getDistrict(place) {
    const COMPONENT_TEMPLATE = { administrative_area_level_2: 'short_name' },
      state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return state;
  }

  getCountryShort(place) {
    const COMPONENT_TEMPLATE = { country: 'short_name' },
      countryShort = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return countryShort;
  }

  getCountry(place) {
    const COMPONENT_TEMPLATE = { country: 'long_name' },
      country = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return country;
  }

  getPostCode(place) {
    const COMPONENT_TEMPLATE = { postal_code: 'long_name' },
      postCode = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return postCode;
  }

  getPhone(place) {
    const COMPONENT_TEMPLATE = { formatted_phone_number: 'formatted_phone_number' },
      phone = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return phone;
  }

  getName(place) {
    const COMPONENT_TEMPLATE = { name: 'name' },
      name = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return name;
  }

  // :::end google address functions



  getJobServiceRule(job_service_rule_id) {
    this._demoService.getJobServiceRule(job_service_rule_id).subscribe(
       data => { this.job_service_rule = data; 
        let res = data[0];
        if (job_service_rule_id <= 0 ){
          this.selected_job_service_rule_description = 'Not Applicable';
        }else{
           this.selected_job_service_rule_description = res.job_service_rule_description;
        };
       
      },
       err => console.log(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobServiceTimeframe(job_service_timeframe_id) {
    this._demoService.getJobServiceTimeframe(job_service_timeframe_id).subscribe(
       data => { this.job_service_timeframe = data; 
        let res = data[0];
        if (job_service_timeframe_id <= 0 ){
          this.selected_job_service_timeframe_description = 'Not Applicable';
        }else{
          this.selected_job_service_timeframe_description = res.job_service_rule_time_frame_text;
        }
        ;
        
      },
       err => console.log(err),
       // () => console.log('done loading Trace Types')
     );
   }



   getJobServiceRules() {
    this._demoService.getJobServiceRules().subscribe(
       data => { this.job_service_rules = data; },
       err => console.log(err),
        () => {
          // console.log('done loading SR');
                      }
          );
   }


   getJobServiceTimeframes() {
    this._demoService.getJobServiceTimeframes().subscribe(
       data => { this.job_service_timeframes = data; },
       err => console.log(err),
        () => {
          // console.log('done loading SR');
                      }
          );
   }


   getSubjectServiceTypes() {
    this._demoService.getSubjectServiceTypes().subscribe(
       data => { this.subject_service_types = data;  },
       err => console.log(err),
        () => {
          // console.log('done loading Subject Service Types')
         // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
         // let mappedJSON = JSON.parse(mapped);
         // console.log('Mapped JSON Array: ' + mappedJSON);
        }
          );
   }

   
  getSubjectServiceType(subject_service_type_id) {
    this._demoService.getSubjectServiceType(subject_service_type_id).subscribe(
       data => { 
        this.subject_service_type = data;
        let res = data[0];
        if ( subject_service_type_id <= 0 ){
          this.selected_subject_service_type_description = 'Please Set to default Individual Above';
          this.selected_subject_service_type_description = '';
          this.selected_subject_service_type_instructions = '';
          this.selected_subject_service_type_staff_instructions = '';

        } else{
        this.selected_subject_service_type_description = res.subject_service_type_description;
        this.selected_subject_service_type_instructions = res.subject_service_type_instructions;
        this.selected_subject_service_type_staff_instructions = res.subject_service_type_staff_instructions;
        }

        // initiate the change of service rule if different or select from drop down.
        if (subject_service_type_id > 1) {
        this.setJobServiceRule(res.job_service_rule_id_change_to);
        this.getJobServiceRule(res.job_service_rule_id_change_to); // sets the descruption information on change.
        }

      },
       err => console.log(err),
       // () => console.log('done loading Trace Types')
     );
   }




   setJobServiceRule(job_service_rule_id) {
    // sets the form value upon change of the subject_service_type
    this.SubjectForm.controls['job_service_rule_id'].setValue(job_service_rule_id);
  //  this.toastr.info('Service Rule modified due to Service Entity Type Change. Please Save Subject Changes.' + job_service_rule_id);
};


onOpenDialogSaveSubject = function(event: any): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Success ',
    // tslint:disable-next-line:max-line-length
    content: '<b>Subject Details Updated and Data Saved successfully.</b> <br><br> <p class="text-success font-bold">You may continue.</p> ',
    okButton: {  text: 'Continue', click: this.okClickSaveSubject.bind(this) },
    cancelButton: {  text: '.', click: this.okClickSaveSubject.bind(this) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}

private okClickSaveSubject(): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.newSubject);
// this.clientJobSubmission(this.job_id);
 this.DialogObj.hide();
}

private cancelClickSaveSubject(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
}




OpenFindAddress() {
  this.loadFindAddress = true;
}

closeFindAddress() {
  this.loadFindAddress = false;
}

OpenFindBusinessAddress() {
  this.loadFindBusinessAddress = true;
}

closeFindBusinessAddress() {
  this.loadFindBusinessAddress = false;
}

// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // this.modalRef = this.modalService.show(template);
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div

// :: Reloads the email list
this.getSubjectContactEmails(this.subject_id);
this.getSubjectContactNumbers(this.subject_id);
this.getJobSubjectDocumentsBySubjectID(this.subject_id);

};


getSubjectContactEmails(subject_id) {
  this._demoService.getSubjectContactEmails(subject_id).subscribe(
     data => { this.subject_contact_emails = data; },
     err => console.log(err),
      () => {
        // console.log('done loading SR');
                    }
        );
 }


 deleteSubjectContactEmail(subject_contact_email_id) {
  if (confirm('Are you sure you want to remove this subject contact email? ')) {
  this._demoService.deleteSubjectContactEmail(subject_contact_email_id).subscribe(
     data => { 
      // this.subject_contact_emails = data;
      this.getSubjectContactEmails(this.subject_id);
      // this.toastr.success('Subject Contact Email Removed');
       },
     err => console.log(err),
      () => {
      //  console.log('done loading SR');
                    }
        );
 }
}




getSubjectContactNumbers(subject_id) {
  this._demoService.getSubjectContactNumbers(subject_id).subscribe(
     data => { this.subject_contact_numbers = data; },
     err => console.log(err),
      () => {
        // console.log('done loading SCN');
                    }
        );
 }


 deleteSubjectContactNumber(subject_contact_number_id) {
  if (confirm('Are you sure you want to remove this subject contact Number? ')) {
  this._demoService.deleteSubjectContactNumber(subject_contact_number_id).subscribe(
     data => { 
      // this.subject_contact_emails = data;
      this.getSubjectContactNumbers(this.subject_id);
      // this.toastr.success('Subject Contact Email Removed');
       },
     err => console.log(err),
      () => {
      //  console.log('done loading SR');
                    }
        );
 }
}


deleteJobSubjectDocument(job_subject_document_id) {
  if (confirm('Are you sure you want to delete this document listing? ')) {
    this._demoService.deleteJobSubjectDocument(job_subject_document_id).subscribe(
       data => {
     // reset the plaintiff list.
     // reset based on which card the user is viewing.
     if(this.subject_id >= 1){
     this.getJobSubjectDocumentsBySubjectID(this.subject_id);
    //  this.toastr.warning('Document listing removed from Subject.');
     }else {
      this.getJobSubjectDocumentsByJobID(this.job_id);
      // this.toastr.warning('Document listing removed from job.');
     }



         return true;
       },
       error => {
        //  console.error('Error deleting !');
        return console.log(error);
       }
    );
}
}



getJobSubjectDocumentsByJobID(job_id) {
  this._demoService.getJobSubjectDocumentsByJobID(job_id).subscribe(
     data => { this.job_subject_documents = data; },
     err => console.log(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobSubjectDocumentsBySubjectID(subject_id) {
  this._demoService.getJobSubjectDocumentsBySubjectID(subject_id).subscribe(
     data => { this.job_subject_documents = data; },
     err => console.log(err),
     // () => console.log('done loading Trace Types')
   );
 }

  /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
    this.selected_tab = tab_id; // so that we can load the queries only when the tabs clicked
  };


  getJobSubjects(job_id) {
    this._demoService.getJobSubjects(job_id).subscribe(
       data => { this.all_job_subjects = data;
        this.all_job_subjects_count = this.all_job_subjects.length;
        let res = data[0];
       // this.getSubjectNotes(res.subject_id);
      },
       err => console.log(err),
       // () => console.log('done loading Trace Types')
     );
   }


   onChangePromtSave(any) {
  //  alert('you have made changes, please remember to save!');
  //  console.log('form changed');
   this.changes_made = null;
  }


  getAssignedAgentsJobsSubjectsGrid(job_id, brand_id, job_status_code, assigned_agent) {
    this._demoService.getAssignedAgentsJobsSubjectsGrid(job_id, brand_id, job_status_code, assigned_agent).subscribe(
      data => {
        this.subjects_urgent2 = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent2 = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);

        this.job_subjects_count = this.subjects_urgent2.length;
        this.job_subjects_not_closed_count = this.subjects_urgent2.filter((item) => item.job_status !== 'CLOSED')
        .map((item) => +item.invoice_id).length;


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }




  /// get the job subjects counts
  getJobsTableDataSubjects(job_id) {
    this._demoService.getJobsTableDataSubjects(job_id).subscribe(
      data => {
        this.subjects_urgent2 = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent2 = DataUtil.parse.parseJson(data);
     

        this.job_subjects_count = this.subjects_urgent2.length;
        this.job_subjects_not_closed_count = this.subjects_urgent2.filter((item) => item.job_status !== 'CLOSED')
        .map((item) => +item.invoice_id).length;

        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }




  copyToClipboard(id) {
    const content = document.getElementById(id).innerHTML; // copy all formatting.
    // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
    this.clipboard.copy(content);
    this,this.toastr.info(" Copied")
    // this.copyInGrid('btnTwo', id);
  }
  
  copyToClipboardPlainText(id) {
    const content = document.getElementById(id).innerText; // copy all formatting.
    // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
    // this.clipboard.copy(this.removeTags(content));
    this.clipboard.copy(content);
    this,this.toastr.info(" Copied")
    // this.copyInGrid('btnTwo', id);
  }
  
    // shows pre version field by id // ngif statments hard coded on each old text box
    showPrevVersion(id) {
      this.showPrevVersion_Field = id;
    
    } 

    hidePrevVersion() {
      this.showPrevVersion_Field = '';
    
    } 
  
  
    importPrevContentToHTML(id, content_sent, model) {
      if (confirm('Are you sure? Warning: This action will replace any content in the new "Editor" for this specific field.' + id)) {
      // model.id = id+'_HTML'
      // const content = document.getElementById(id).innerText; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      // this.clipboard.copy(this.removeTags(content));
      // this.clipboard.copy(content);

      const content = content_sent; // copy all formatting.
      // this.attemptForm.controls['updated_by'].setValue(id+'_HTML');
      

      // this.attemptForm.controls['general_notes_HTML'].setValue(content);
      this.SubjectForm.controls[id+'_HTML'].setValue(content);
      this.toastr.info("Imported Prev Version: " + id+'_HTML')
      // this.LoadSubjectserviceOutcomeTemplateParagraph(model)
      // this.copyInGrid('btnTwo', id);
      }
    }


    importPrevContentToHTML_Direct(id, content_sent, model) {
      if (confirm('Are you sure? Warning: This action will replace any content in the new "Editor" for this specific field.' + id)) {
      // model.id = id+'_HTML'
      // const content = document.getElementById(id).innerText; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      // this.clipboard.copy(this.removeTags(content));
      // this.clipboard.copy(content);

  // const content = content_sent; // copy all formatting.
      // this.attemptForm.controls['updated_by'].setValue(id+'_HTML');
      const content = this.SubjectForm.controls[id].getRawValue(); // wet to copy text and formatting only
      

      console.log('Content: ' + content);

      // this.attemptForm.controls['general_notes_HTML'].setValue(content);
  this.SubjectForm.controls[id+'_HTML'].setValue(content);
      // this.defaultRTE.editor.paste(content);

      this.toastr.info("Imported Prev Version: " + id+'_HTML')
      // this.LoadSubjectserviceOutcomeTemplateParagraph(model)
      // this.copyInGrid('btnTwo', id);
      }
    }


    getJobPlaintiffs(job_id) {
      this._demoService.getJobPlaintiffs(job_id).subscribe(
         data => { this.job_plaintiffs = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    


     deleteJobPlaintiff(job_plaintiff_id) {
      if (confirm('Are you sure you want to delete this Plaintiff? ')) {
        this._demoService.deleteJobPlaintiff(job_plaintiff_id).subscribe(
           data => {
         // reset the plaintiff list.
         this.getJobPlaintiffs(this.job_id);
        //  this.toastr.warning('Plaintiff removed from job.');
             return true;
           },
           error => {
             console.error('Error deleting !');
            //  return Observable.throw(error);
           }
        );
    }
    }






getTimeframeSurcharges() {
  this._demoService.getTimeframeSurcharges().subscribe(
     data => { this.timeframe_surcharges = data;  },
     err => console.error(err),
      () => {
        // console.log('done loading Subject Service Types')
       // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
       // let mappedJSON = JSON.parse(mapped);
       // console.log('Mapped JSON Array: ' + mappedJSON);
      }
        );
 }







}




// Allows formatting of dates etc...
export class DatePipeComponent {
  today: number = Date.now();
  fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
  // tslint:disable-next-line:eofline
}







/*
**** :: Google JSON: returned Address lookup Results   ::
*/

/*

{
   "html_attributions" : [],
   "result" : {
      "address_components" : [
         {
            "long_name" : "5",
            "short_name" : "5",
            "types" : [ "floor" ]
         },
         {
            "long_name" : "48",
            "short_name" : "48",
            "types" : [ "street_number" ]
         },
         {
            "long_name" : "Pirrama Road",
            "short_name" : "Pirrama Rd",
            "types" : [ "route" ]
         },
         {
            "long_name" : "Pyrmont",
            "short_name" : "Pyrmont",
            "types" : [ "locality", "political" ]
         },
         {
            "long_name" : "Council of the City of Sydney",
            "short_name" : "Sydney",
            "types" : [ "administrative_area_level_2", "political" ]
         },
         {
            "long_name" : "New South Wales",
            "short_name" : "NSW",
            "types" : [ "administrative_area_level_1", "political" ]
         },
         {
            "long_name" : "Australia",
            "short_name" : "AU",
            "types" : [ "country", "political" ]
         },
         {
            "long_name" : "2009",
            "short_name" : "2009",
            "types" : [ "postal_code" ]
         }
      ],
      "adr_address" : "5, \u003cspan class=\"street-address\"\u003e48 Pirrama Rd\u003c/span\u003e, \u003cspan class=\"locality\"\u003ePyrmont\u003c/span\u003e \u003cspan class=\"region\"\u003eNSW\u003c/span\u003e \u003cspan class=\"postal-code\"\u003e2009\u003c/span\u003e, \u003cspan class=\"country-name\"\u003eAustralia\u003c/span\u003e",
      "formatted_address" : "5, 48 Pirrama Rd, Pyrmont NSW 2009, Australia",
      "formatted_phone_number" : "(02) 9374 4000",
      "geometry" : {
         "location" : {
            "lat" : -33.866651,
            "lng" : 151.195827
         },
         "viewport" : {
            "northeast" : {
               "lat" : -33.8653881697085,
               "lng" : 151.1969739802915
            },
            "southwest" : {
               "lat" : -33.86808613029149,
               "lng" : 151.1942760197085
            }
         }
      },
      "icon" : "https://maps.gstatic.com/mapfiles/place_api/icons/generic_business-71.png",
      "international_phone_number" : "+61 2 9374 4000",
      "name" : "Google",
      "place_id" : "ChIJN1t_tDeuEmsRUsoyG83frY4",
      "rating" : 4.5,
      "reference" : "ChIJN1t_tDeuEmsRUsoyG83frY4",
      "reviews" : [
         {
            "author_name" : "Robert Ardill",
            "author_url" : "https://www.google.com/maps/contrib/106422854611155436041/reviews",
            "language" : "en",
            "profile_photo_url" : "https://lh3.googleusercontent.com/-T47KxWuAoJU/AAAAAAAAAAI/AAAAAAAAAZo/BDmyI12BZAs/s128-c0x00000000-cc-rp-mo-ba1/photo.jpg",
            "rating" : 5,
            "relative_time_description" : "a month ago",
            "text" : "Awesome offices. Great facilities, location and views. Staff are great hosts",
            "time" : 1491144016
         }
      ],
      "types" : [ "point_of_interest", "establishment" ],
      "url" : "https://maps.google.com/?cid=10281119596374313554",
      "utc_offset" : 600,
      "vicinity" : "5, 48 Pirrama Road, Pyrmont",
      "website" : "https://www.google.com.au/about/careers/locations/sydney/"
   },
   "status" : "OK"
   "info_messages" : [
      "Unsupported request parameter value: 'foo' ignored.",
      "Unsupported request parameter value: 'bar' ignored.",
   ],
}
      
*/

// :::
